
import React, { PropTypes } from 'react';

import './style.scss';

const ArticleOuter = props => {
  return (
    <div className="ArticleOuter">
      {props.children}
    </div>
  );
};

ArticleOuter.propTypes = {
  children: PropTypes.element
};

export default ArticleOuter;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ArticleOuter/index.js
 **/